// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PaymentMethodsSectionPreview_wrapper__qs2yc","title":"PaymentMethodsSectionPreview_title__EEHy_","subtitle":"PaymentMethodsSectionPreview_subtitle__nN0Wb"};